import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface NotificationItem {
  id: number;
  sender: number;
  receiver: number;
  header: string;
  redirect_id: string | null;
  type: string;
  message: string;
  is_read: boolean;
  is_deleted: boolean;
  created_at: string;
}

export interface NotificationsState {
  list: NotificationItem[];
  totalCount: number;
  unreadCount: number;
  loading: boolean;
  error: string | null;
  roleChanged: boolean; // New state for role change modal
}

const initialState: NotificationsState = {
  list: [],
  totalCount: 0,
  unreadCount: 0,
  loading: false,
  error: null,
  roleChanged: false, // Initialize role change modal state
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotificationsList: (state, action: PayloadAction<NotificationItem[]>) => {
      state.list = action.payload;
    },
    setNotificationsTotalCount: (state, action: PayloadAction<number>) => {
      state.totalCount = action.payload;
    },
    setNotificationsUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    setNotificationsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setNotificationsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    markAllReadLocally: (state) => {
      state.list = state.list.map((n) => ({ ...n, is_read: true }));
      state.unreadCount = 0;
    },
    markOneReadLocally: (state, action: PayloadAction<number>) => {
      const n = state.list.find((x) => x.id === action.payload);
      if (n && !n.is_read) {
        n.is_read = true;
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markOneUnreadLocally: (state, action: PayloadAction<number>) => {
    const n = state.list.find((x) => x.id === action.payload);
     if (n && n.is_read) {
        n.is_read = false;
        state.unreadCount += 1;
      }
    },
    clearNotificationsLocally: (state) => {
      state.list = [];
      state.totalCount = 0;
      state.unreadCount = 0;
    },
    removeFromDropdown: (state, action: PayloadAction<number>) => {
    state.list = state.list.filter((n) => n.id !== action.payload);
    state.totalCount = Math.max(0, state.totalCount - 1);
    },
    setRoleChanged: (state, action: PayloadAction<boolean>) => { 
      state.roleChanged = action.payload;
    },
  },
});

export const {
  setNotificationsList,
  setNotificationsTotalCount,
  setNotificationsUnreadCount,
  setNotificationsLoading,
  setNotificationsError,
  markAllReadLocally,
  markOneReadLocally,
  markOneUnreadLocally,
  clearNotificationsLocally,
  removeFromDropdown,
  setRoleChanged,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;